export default "﻿<div>\r\n    <div data-bind=\"control: { uiGenerator: 'Image', viewModel: viewModel.image }\"></div>\r\n</div>"